import { BackendModel, BackendService } from "../../core/backend.service";

export class CostoEnvioMasivo {

    static path = '/costo-envio/modificacion-masiva';

    etiquetaModificacionPrecio: string;
    aumentoPrecio: number = 0;
  
    
  }


// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio-masivo.model.ts